import {Command} from "./Command";
import {GamePlay} from "../model/game-play";
import {Down} from "../model/down";

export class SetDownCommand implements Command {
  constructor(
    private gamePlay: GamePlay,
    private down: Down
  ) { }

  execute() {
    console.log('COMMAND SetDownCommand', this.down)
    this.gamePlay.down = this.down
  }
}
